module.exports = __webpack_public_path__ + "img/8.9c3d5487.gif";